import { createLogic } from "redux-logic";
import {
    type HistoryEventType,
    HISTORY_EVENT,
    setFinanceOption,
} from "../../../../../common-deprecated/redux/actions/UtilActions";
import { queryStringToObject } from "../../../../../common-deprecated/utils";
import { popBasketHistory } from "../actions/BasketActions";
import { COMPONENT_BUILDANDBUY } from "../../../../../shared-logic/server/components";
import { HISTORY_TYPE_PROP } from "../../../../../common-deprecated/History";
import type { BuildAndBuyLogicType } from "../store";
import type { FinanceOptionType } from "../../../../../common-deprecated/types/CommonTypes";

const historyLogic = (createLogic as BuildAndBuyLogicType<HistoryEventType>)({
    type: HISTORY_EVENT,

    validate({ action }, allow, reject) {
        // For now we're only acting on on POP action events because we have no need to listen to PUSH (no state updates).
        if (action.actionType === "POP") allow(action);
        else (reject as () => void)();
    },

    process({ action, getState }, dispatch, done) {
        const { commonSettings, utils } = getState();
        const { location } = action;
        const query = queryStringToObject(location.search);
        // Determine which actions need to be fired based data from the location object.
        if (query.financeOption && query.financeOption !== utils.financeOption) {
            // Different financeOption => Set financeOption
            dispatch(setFinanceOption((query.financeOption as FinanceOptionType) || "cash", true));
            // All OR history actions have the HISTORY_TYPE_PROP in state to show that this is a history action done by OR. Exception being the financeOption. See OR-1737.
        } else if (
            location.state &&
            !!location.state[HISTORY_TYPE_PROP] &&
            commonSettings.component === COMPONENT_BUILDANDBUY
        ) {
            // location.state.type can potentially be used here to further determine the type of history pop that happened.
            // Currently not necessary because we can determine which action happened based on the active component.
            dispatch(popBasketHistory(query, true));
        }
        done();
    },
});

export default [historyLogic];
